import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-basic-spinner",
  templateUrl: "./basic-spinner.component.html",
  styleUrls: ["./basic-spinner.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BasicSpinnerComponent {
  @Input() public diameter: number = 30;
  @Input() public strokeWidth: number = 2;
  @Input() public color: string | null = null;
}
